import * as Styled from "domains/moderate/sources/components/SourceListItem/SourceListItem.styled";

type SourceListItemProps = {
  isSelected: boolean;
  id: string;
  name: string;
  imageUrl?: string;
  isActive?: boolean;
  type?: string;
  publicationType?: string;
};

export const SourceListItem = ({
  isSelected,
  id,
  name,
  imageUrl,
  isActive = false,
  type,
  publicationType,
}: SourceListItemProps) => (
  <Styled.SourceListItemContainer to={`/moderate/sources/${id}`} $isSelected={isSelected}>
    <Styled.StatusTag isActive={isActive}>{isActive ? "Active" : "Inactive"}</Styled.StatusTag>
    <Styled.ContentContainer>
      <div style={{ aspectRatio: 1 }}>
        <Styled.SourceImage src={imageUrl} alt={name} />
      </div>
      <Styled.TextContainer>
        <Styled.SourceName>{name}</Styled.SourceName>
        <Styled.TagContainer>
          {type && <Styled.SourceTypeTag>{type}</Styled.SourceTypeTag>}
          {publicationType && <Styled.SourceTypeTag>{publicationType}</Styled.SourceTypeTag>}
        </Styled.TagContainer>
      </Styled.TextContainer>
    </Styled.ContentContainer>
  </Styled.SourceListItemContainer>
);
